<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div>
    <PageHeader :title="$t('Your invoices')" />
    <InvoiceList :planSaleBillings="index" />
    <Pagination
      :currentPage="currentPage"
      :totalPages="totalPages"
      :totalCount="totalCount"
      @changePage="handleChangePage"
    />
  </div>
</template>

<script>
import { PageHeader, Pagination } from "@estaly/ui";
import InvoiceList from "@/components/InvoiceList.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    PageHeader,
    InvoiceList,
    Pagination,
  },
  computed: {
    ...mapState("planSaleBillings", ["index", "currentPage", "totalPages", "totalCount"]),
  },
  created() {
    this.fetchIndex({ page: 1, billingType: "collected" });
  },

  methods: {
    ...mapActions("planSaleBillings", ["fetchIndex"]),

    handleChangePage(page) {
      this.fetchIndex({ page, billingType: "collected" });
    },
  },
};
</script>
